import { jsx as _jsx } from "react/jsx-runtime";
export default function DropdownIcon(props) {
    return /*#__PURE__*/ _jsx("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1 1L5 5L9 1",
            strokeWidth: "1.5"
        })
    });
}
